export const doesChannelMatchSearch = (
  channelId: number,
  channelName: string,
  channelMsgMedium: string,
  channelType: string,
  search: string,
) =>
  search.length === 0 || // Pass all options through if search string is empty
  channelId.toString().includes(search.toLowerCase()) || // Pass options with matching IDs
  channelName.toLowerCase().includes(search.toLowerCase()) || // Pass options with matching names
  channelMsgMedium.toLowerCase().includes(search.toLowerCase()) || // Pass options with matching msg mediums
  channelType.toLowerCase().includes(search.toLowerCase()); // Pass options with matching channel types
